// Community articles for the Help Center: Teams, Social and Project Studio.

const community = {
  slug: 'community',
  label: 'Community',
  icon: 'PiUsers',
  description: 'Teams, your school’s Social pages, and Project Studio.',
  articles: [
    {
      slug: 'working-as-a-team',
      title: 'Working as a team',
      summary: 'Pool your skills under one profile to take on bigger work, or hire as a group.',
      body: [
        {
          type: 'p',
          text: 'A team brings several people together under one shared profile. When you start a team you choose what it is for, and that choice is fixed once the team exists: a services team lists work together, and a hiring team posts jobs and reviews applicants as a group.',
        },
        {
          type: 'steps',
          items: [
            'Go to Teams and choose Start a team.',
            'Pick Offer services or Hire together.',
            'Choose who can join: invite-only, where only admins can add people, or open to requests, where anyone can ask and an admin approves.',
            'Add a name, a headline and a picture, then invite your teammates.',
          ],
        },
        {
          type: 'p',
          text: 'Team members are either admins or members. Admins can invite people, approve join requests and change other members’ roles.',
        },
        {
          type: 'note',
          text: 'A team service is published by one member. Orders and payouts go through that member’s account, so agree on how you will split earnings before you take on work.',
        },
      ],
    },
    {
      slug: 'social-courses-and-board',
      title: 'Social: courses, study tables and your school’s board',
      summary: 'Find people taking the same courses, ask questions, and join study tables.',
      body: [
        {
          type: 'p',
          text: 'Social is organized around your university, so set your school on your profile first. It has three tabs: Courses, Board and Community.',
        },
        {
          type: 'list',
          items: [
            'Courses lists every course people at your school have added, with the questions waiting for an answer and any study tables.',
            'Each course has its own page: questions people are stuck on, who has taken it and can help, tutors you can hire, and study tables.',
            'Board is your school’s discussion board, for anything that isn’t about one course.',
          ],
        },
        {
          type: 'p',
          text: 'Study tables are free, peer-led study sessions for one course, shown in the host’s local time. Tutoring is paid: a course’s tutors are people who have taken it and offer one-to-one help as a service you can book.',
        },
      ],
    },
    {
      slug: 'project-studio',
      title: 'What Project Studio is',
      summary: 'Real client-style projects for credit, run by your instructor.',
      body: [
        {
          type: 'p',
          text: 'Project Studio gives students a project written the way a real client would describe a real need, with milestones and feedback along the way instead of a single graded assignment.',
        },
        {
          type: 'list',
          items: [
            'Instructors choose individual work or self-formed teams.',
            'A project can be scoped to one class, or opened to every student at the school.',
            'Faculty write the brief, set milestones, grade submissions and can promote students to mentors.',
          ],
        },
        {
          type: 'p',
          text: 'Students join a class with the code their instructor shares, then find their projects in Project Studio. Faculty can apply for Project Studio access from the Project Studio page.',
        },
      ],
    },
  ],
};

export default community;
